import { useMutation } from "@tanstack/react-query";

import SharedRecordAPI from "../../api/SharedRecordAPI";
import { getErrorMessage } from "../../../utils/GeneralUtils";

interface Props {
  sharedRecordID: string;
  cloudID: string;
  onSuccess: (newRecordID: string) => void;
  onError: (err: string) => void;
}

export default function useUpdateRecordWithShared() {
  const updateRecordWithShared = useMutation({
    mutationFn: ({ sharedRecordID, cloudID }: Props) =>
      SharedRecordAPI.updateRecordWithShared(sharedRecordID, cloudID).then(
        (data) => data.data.data.recordID
      ),
    onSuccess: (recordID, { onSuccess }) => {
      onSuccess(recordID);
    },
    onError: (err, { onError }) => {
      onError(getErrorMessage(err));
    },
  });

  return {
    updateRecordWithShared: updateRecordWithShared.mutate,
    updatingRecord: updateRecordWithShared.isPending,
  };
}
